import ArrowRight from '@/assets/icons/arrow-right.svg?react'
import { URLS } from '@/pages/urls'
import { Text } from '@/ui-kit'
import { SquareArrowOutUpRight } from 'lucide-react'
import { Link } from 'react-router-dom'

export const ReferralProgramInfo = () => {
  return (
    <div className="grow">
      <div className="rounded-2xl border border-solid border-gray-100 p-6 py-8">
        <div className="max-mobile:flex-col max-mobile:items-center flex gap-12">
          <div className="flex max-w-[222px] flex-col items-center gap-3">
            <div className="max-h-[140px] max-w-[140px] scale-125">
              <img className="object-contain" src="/images/refer.png" />
            </div>
            <Text type="h5" className="text-gray-70 text-center">
              Refer your friends
            </Text>
            <Text className="text-center text-[var(--colorGray80to90)]">
              Invite your friends and colleagues to join, and both of you will be rewarded!
            </Text>
          </div>
          <div className="max-mobile:rotate-90 text-gray-90 m-auto flex h-[64px] w-[64px] flex-shrink-0 items-center justify-center rounded-full border border-solid border-gray-100">
            <ArrowRight width={36} />
          </div>
          <div className="flex max-w-[222px] flex-col items-center gap-3">
            <div className="max-h-[140px] max-w-[140px]">
              <img className="object-contain" src="/images/points.png" />
            </div>
            <Text type="h5" className="text-center text-[var(--colorGray70to100)]">
              Get points
            </Text>
            <Text type="body1-regular" className="text-center text-[var(--colorGray80to90)]">
              When someone signs up using your referral link, you’ll earn exclusive rewards for each successful
              referral.
            </Text>
          </div>
          <div className="text-gray-90 max-mobile:rotate-90 m-auto flex h-[64px] w-[64px] flex-shrink-0 items-center justify-center rounded-full border border-solid border-gray-100">
            <ArrowRight width={36} />
          </div>
          <div className="flex max-w-[222px] flex-col items-center gap-3">
            <div className="max-h-[140px] max-w-[140px] flex-shrink">
              <img className="object-contain" src="/images/three-tier.png" />
            </div>
            <Text type="h5" className="text-center text-[var(--colorGray70to100)]">
              Three-tier referral system
            </Text>
            <Text type="body1-regular" className="text-center text-[var(--colorGray80to90)]">
              Get rewards from friends of friends—the more you invite, the more you earn!
            </Text>
          </div>
        </div>
        <div className="mt-6 border-t border-solid border-gray-100 pt-6">
          <Link
            className="group text-gray-90 flex items-center justify-center gap-2"
            to={URLS.BLOG_REFERRAL_PROGRAM}
            target="_blank"
            rel="noreferrer"
          >
            <span className="text-[var(--colorWhiteToBlack)] underline transition-colors duration-300 group-hover:text-[var(--colorGreen)]">
              More information in our blog
            </span>
            <SquareArrowOutUpRight
              size={20}
              className="transition-colors duration-300 group-hover:text-[var(--colorGreen)]"
            />
          </Link>
        </div>
      </div>
    </div>
  )
}
